import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-game-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './game-card.component.html',
  styleUrl: './game-card.component.scss',
})
export class GameCardComponent {
  @Input() game: any;
  @Input() statusLabel: string = 'PLAY';
  @Input() statusActive: boolean = false;
  @Input() rotate: boolean = false;
  @Output() cardClick = new EventEmitter<void>();

  get displayName(): string {
    const name = this.game?.name || '';
    return name === 'Juwa2' ? 'Juwa2.0' : name;
  }

get cardBackground(): string {
  if (!this.game) {
    return 'linear-gradient(180deg,#ef3d67 0%,#7b5cff 45%,#1db8ff 100%)';
  }

  const bg = this.game.bgclr || '#ef3d67';
  const c2 = this.game.color2 || '#7b5cff';
  const c3 = this.game.color3 || '#1db8ff';

  return `linear-gradient(
    180deg,
    ${bg} 0%,
    ${c2} 45%,
    ${c3} 100%
  )`;
}
  get cardImage(): string {
    return this.game?.image || this.game?.coverImage || '/Images/placeholder.png';
  }

  onClick(): void {
    this.cardClick.emit();
  }
}
